import React, { useState } from "react";
import { BellRing, Loader2, ShieldAlert, Radar } from "lucide-react";
import ActiveCardShell from "../ActiveCardShell";
import { sleep, RunButton, useAlive } from "../phase2/shared";

const TXS = [
  ["•••• 4412", "$38.20", "In person · Columbus, OH", 6],
  ["•••• 9087", "$61.75", "In person · Columbus, OH", 9],
  ["•••• 2231", "$24.10", "Tap · Columbus, OH", 4],
  ["•••• 7719", "$2,480.00", "Card not present · Miami, FL", 91],
  ["•••• 5530", "$47.90", "In person · Dublin, OH", 11],
];

export default function FraudCard({ merchant, onCatch }) {
  const [shown, setShown] = useState(0);
  const [alerted, setAlerted] = useState(false);
  const [running, setRunning] = useState(false);
  const alive = useAlive();

  const run = async () => {
    setRunning(true); setShown(0); setAlerted(false);
    for (let i = 1; i <= TXS.length; i += 1) { await sleep(520); if (!alive.current) return; setShown(i); }
    await sleep(600);
    if (!alive.current) return;
    setAlerted(true);
    setRunning(false);
    onCatch?.("fraud-7719");
  };

  return (
    <ActiveCardShell id="T3200cr" kicker="PORTFOLIO RISK" title="Fraud Scoring & Anomaly Alerts" Icon={ShieldAlert}
      actions={<RunButton tid="veroogle-t3200-run" running={running} onClick={run} Icon={running ? Loader2 : Radar} label="Watch transactions" />}>
      <ul className="space-y-1.5">
        {TXS.slice(0, shown).map(([card, amt, where, score], i) => {
          const bad = score > 80;
          return (
            <li key={card} data-testid={`veroogle-t3200-tx-${i}`}
              className={`flex items-center gap-3 rounded-lg border px-3 py-2 animate-in fade-in slide-in-from-top-1 ${bad ? "border-rose-500/70 bg-rose-500/15 shadow-[0_0_18px_rgba(244,63,94,0.45)]" : "border-white/10 bg-navy-950/40"}`}>
              <span className="font-mono text-xs text-slate-400 w-20">{card}</span>
              <span className="font-mono text-sm text-white w-24">{amt}</span>
              <span className="text-xs text-slate-400 flex-1 truncate">{where}</span>
              <span className={`font-mono text-xs px-2 py-0.5 rounded ${bad ? "bg-rose-500 text-white" : "bg-emerald-500/15 text-emerald-300"}`}>{score}</span>
              {bad && <span data-testid="veroogle-t3200-held" className="font-mono text-[9px] tracking-[0.14em] uppercase text-rose-300 hidden sm:inline">Held for review</span>}
            </li>
          );
        })}
      </ul>
      {alerted && (
        <div data-testid="veroogle-t3200-alert" className="mt-3 inline-flex items-center gap-2 px-3 py-1.5 rounded-lg border border-rose-400/40 bg-rose-500/10 text-rose-200 text-xs animate-in fade-in">
          <BellRing className="w-3.5 h-3.5" /> $2,480 held · owner of {merchant.name} alerted by text
        </div>
      )}
    </ActiveCardShell>
  );
}
